import * as React from "react";
import type { SVGProps } from "react";
const SvgFacebookNegative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      d="m13.173 10.938.411-2.696h-2.613V6.484c0-.761.352-1.464 1.527-1.464h1.204V2.705S12.615 2.5 11.587 2.5c-2.144 0-3.554 1.318-3.554 3.662v2.08H5.625v2.695h2.408V17.5h2.938v-6.562z"
    />
  </svg>
);
export default SvgFacebookNegative;
